import { Link } from "react-router-dom";
import { news } from "@/mocks/news";

export default function NewsList() {
  return (
    <ul className="divide-y divide-background-200">
      {news.length === 0 ? (
        <li className="py-6 text-sm text-foreground-500">暂无相关影视资讯，敬请期待</li>
      ) : (
        news.map((item) => (
          <li key={item.id}>
            <Link
              to={item.relatedMovieId ? `/detail/${item.relatedMovieId}` : "/"}
              className="group flex items-start gap-3 py-3.5"
            >
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600 md:text-base">
                  {item.title}
                </span>
                <span className="mt-1 hidden text-xs leading-relaxed text-foreground-500 sm:block">
                  {item.summary}
                </span>
              </span>
              <time className="shrink-0 whitespace-nowrap text-xs text-foreground-400">
                {item.publishedAt}
              </time>
            </Link>
          </li>
        ))
      )}
    </ul>
  );
}